import React from 'react';
import { StyledTBody } from './styles';

export type TBodyProps = React.HTMLAttributes<HTMLTableSectionElement>;

const TBody: React.FC<TBodyProps> = props => <StyledTBody {...props} />;

export default TBody;
